import { useTranslation } from 'react-i18next';
import { CiGlobe } from 'react-icons/ci';

import { useGlobalStore } from '@cccom/config/global-store';

type SwitchingSiteProps = { hasXSiteParam?: boolean };

export function SwitchingSite({ hasXSiteParam }: SwitchingSiteProps) {
  const [t] = useTranslation();
  const site = useGlobalStore((state) => state.currentSite);
  const setIsSwitchingSite = useGlobalStore(
    (state) => state.setIsSwitchingSite
  );
  setTimeout(() => setIsSwitchingSite(false), 2000);

  return (
    <div
      className="flex h-screen flex-col items-center justify-center"
      role="status"
      aria-live="polite"
      aria-label={
        site?.name && !hasXSiteParam
          ? t('sites.switching_site_to', { site: site?.name })
          : t('sites.switching_site')
      }
    >
      <CiGlobe className="h-10 w-10 animate-spin" aria-hidden="true" />
      <h1 className="mt-4 text-xl font-medium text-gray-700">
        {site?.name && !hasXSiteParam
          ? t('sites.switching_site_to', { site: site?.name })
          : t('sites.switching_site')}
      </h1>
    </div>
  );
}
